<template>
    <HeaderContent title="Destination" />
    <ActionContent
        ctaText="Destination"
        :filterDate="false"
        :filterModal="false"
        @action="modal = !modal"
        @search-query="searchData"
    />
    <DestinationForm
        :modal="modal"
        :selectedData="selectedData"
        @update:modal="updateModal"
        @addOrUpdate="getAll"
    ></DestinationForm>

    <DataTable
        :data="routeList"
        :header="headers"
        :custom-actions="customActions"
    >
    </DataTable>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import DestinationForm from "./DestinationForm.vue";
import DataTable from "@/components/DataTable.vue";
import { ref, onMounted, inject } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";

const auth = useAuthStore();
const $loading = useLoading();
const selectedData = ref({});
const modal = ref(false);
const swal = inject("$swal");
const toast = useToast();

const headers = ref([
    { key: "code", label: "Code", sortable: true },
    { key: "name", label: "Name", sortable: true },
    { key: "action", label: "Action" },
]);
const customActions = ref([
    {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
            selectedData.value = item;
            modal.value = true;
        },
    },
    {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
            swal({
                title: "Confirm",
                text: "Are you sure to delete this data?",
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded",
                    confirmButton: "btn btn-danger me-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false,
            }).then((confirm) => {
                if (confirm.value) {
                    deleteData(item.uuid);
                } else {
                    swal.close();
                }
            });
        },
    },
]);

const searchData = async (search) => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll(search);
    } finally {
        loader.hide();
    }
};

const updateModal = (newValue) => {
    modal.value = newValue;
};

let routeList = ref([]);

const getAll = async (search = "") => {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/destination`, {
        params: {
            search: search,
        },
        headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + auth._token,
        },
    });

    const res = response.data;

    if (res.status) {
        routeList.value = res.data;
    }
};

const deleteData = async (uuid) => {
    if (uuid) {
        toast.clear();
        const loader = $loading.show({
            color: "#009689",
            loader: "bars",
            zIndex: 999999,
        });

        try {
            const response = await axios.delete(
                `${process.env.VUE_APP_API_URL}/destination/delete/${uuid}`,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                getAll();
            }
        } finally {
            loader.hide();
        }
    }
};

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll();
    } finally {
        loader.hide();
    }
});
</script>
